export default __webpack_public_path__ + "static/media/PPI-driveway-002.85fc0d68.jpg";